import React from 'react';
import { IShowDetails, IStickyOffer, IStickyOfferNextDisable } from './stickyOffer.model';

const observeHeight = (ref: React.MutableRefObject<HTMLDivElement>): void => {
  const body = document.getElementsByTagName('body')?.[0];
  if (!body) return;
  const bodyWidth = body.getBoundingClientRect()?.width;
  const bodyHeight = body.getBoundingClientRect()?.height;
  let wrapperNote;
  body.childNodes.forEach((note) => {
    const noteElement = note as HTMLElement;
    if (noteElement.clientWidth === bodyWidth && noteElement.clientHeight === bodyHeight) {
      wrapperNote = note;
    }
  });
  wrapperNote &&
    (wrapperNote as HTMLElement)?.childNodes.forEach((note) => {
      const noteElement = note as HTMLElement;
      if (noteElement.clientWidth === bodyWidth && noteElement.clientHeight >= bodyHeight) {
        noteElement.style.paddingBottom = `${ref.current.clientHeight}px`;
      }
    });
};

const renderDescription = (des: IStickyOffer['description'], showDetails: IShowDetails) => {
  if (typeof des === 'string') return des;

  return showDetails !== 'slide-up'
    ? des?.openProductDetails || 'MOSTRA DETTAGLI'
    : des?.closeProductDetails || 'NASCONDI DETTAGLI';
};

const isDisabled = (props: IStickyOfferNextDisable): boolean => {
  const { isLoadingGoNext, variant, isDisabled, isLoading } = props;

  if (isLoadingGoNext || variant) return false;
  return !!(isDisabled || isLoading);
};

export { observeHeight, renderDescription, isDisabled };

